module.exports = __webpack_public_path__ + "img/m_icon3.02eb967c.png";